import fetchPosts from "common/fetch/fetchPosts";
import fetchSeo from "common/fetch/fetchSeo";
import getEntityCountries from "common/fetch/getEntityCountries";

import Layout from "components/common/Layout";
import EntityNameCheck from "components/templates/offshore/guide-and-tool/company-name-check";

import dataJson from "./data.json";
export default function Home({ data }) {
  return (
    <div>
      <Layout locationRouter="sg" page={data.page}>
        <EntityNameCheck dataJson={dataJson} data={data} />
      </Layout>
    </div>
  );
}

export const getStaticProps = async () => {
  const locale = "sg";
  const uri = "/guide-and-tool/singapore-company-name-check";
  const page = await fetchSeo({
    uri,
    locale,
  });
  const resEntity = await getEntityCountries();
  const posts = await fetchPosts({
    postPerPage: 4,
    featuredImage: "LARGE",
    gqlNode: `
    categories {
      nodes {
        name
        uri
        parent {
          node {
            id
          }
        }
      }
    }`,
    locale,
  });

  return {
    props: {
      data: {
        page: page || {},
        posts: posts?.nodes || [],
        countries: resEntity || {},
      },
      revalidate: 1,
    },
  };
};
